<template>
  <div v-if="sections.length" class="charts">
    <StatisticsCard v-for="section in sections" :key="section.title" :span="section.table ? 12 : 6" :title="section.title" :subtitle="section.subtitle ?? ''">
      <dl v-if="section.facts && section.facts.length" class="facts" :class="{spaced: section.table}">
        <div v-for="fact in section.facts" :key="fact.label">
          <dt>{{ fact.label }}</dt>
          <dd :class="fact.tone">{{ fact.value ?? '—' }}</dd>
          <small v-if="fact.hint" class="hint">{{ fact.hint }}</small>
        </div>
      </dl>
      <ActivityTable v-if="section.table" :table="section.table" empty-text="Rien à signaler." />
    </StatisticsCard>
  </div>
</template>

<script>
import StatisticsCard from "@/statistics/components/StatisticsCard.vue";
import ActivityTable from "@/administration/components/ActivityTable.vue";

/**
 * Ce que le container ajoute à ses mesures (extras.sections) : des chiffres (facts) et des tableaux, par exemple l'état des services
 * derrière la passerelle ou les documents générés. extras : {sections, alerts} (les alertes sont déjà dans celles du container).
 */
export default {
  name: 'ContainerExtras',
  components: {StatisticsCard, ActivityTable},
  props: {
    extras: {type: Object, default: () => ({sections: []})},
  },
  computed: {
    sections() {
      return this.extras?.sections ?? [];
    },
  },
};
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

.facts
  display grid
  grid-template-columns repeat(auto-fill, minmax(170px, 1fr))
  gap 12px 20px
  margin 0

  &.spaced
    margin-bottom 16px

  dt
    font-size 12px
    color CTRL_TEXT_MUTED

  dd
    margin 2px 0 0
    font-size 13.5px
    font-weight 600
    color #3f3931
    overflow-wrap anywhere

    &.ok
      color #1f6b3a

    &.warn
      color #8a5a00

    &.bad
      color CTRL_ERROR

.hint
  font-size 11.5px
  color CTRL_TEXT_MUTED
</style>
